import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import rootReducer from '../reducers'
import configureStore from 'Shared/configureStore'
import StatisticsContainer from './StatisticsContainer'


const StatisticsRoot = ({
  fetchInitialDataURL,
}) => {
  const state = {
    misc: {
      fetchInitialDataURL,
    },
  }

  const store = configureStore(rootReducer, state)

  return <Provider store={ store }><StatisticsContainer></StatisticsContainer></Provider>
}

StatisticsRoot.propTypes = {
  fetchInitialDataURL: PropTypes.string.isRequired,
}

export default StatisticsRoot
